module.exports = __webpack_public_path__ + "static/img/thumb_4_po.cb1fde2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/index/thumb_4_po.jpg
// module id = 56
// module chunks = 0